import React from 'react';
import DatePicker from './controls/date-picker';
import TimePicker from './controls/time-picker';

interface IProps {
  date: string;
  time: string;
  readOnly: boolean;
  inline: boolean;
  label: string;
  errored: boolean;
  warning: boolean;

  onDateChange: (date: string) => void;
  onTimeChange: (date: string) => void;
}

class Editable extends React.Component<IProps> {
  render() {
    const { date, errored, time, warning, onDateChange, onTimeChange, ...other } = this.props;

    return (
      <React.Fragment>
        <DatePicker
          {...other}
          errored={errored}
          value={date}
          warning={warning}
          onChange={onDateChange}
        />
        <TimePicker errored={errored} value={time} warning={warning} onChange={onTimeChange} />
      </React.Fragment>
    );
  }
}

export default Editable;
